import { useUnsafeAsyncData } from 'modules/core/hooks/useAsyncData'

import questionGroups from 'modules/surveys/store/collections/questionGroups'

export function useQuestionGroups(formId: string) {
  const { loading } = useUnsafeAsyncData(
    async () =>
      questionGroups.fetch({
        data: {
          surveys_form_id: formId,
        },
      }),
    [formId]
  )

  return {
    loading,
    questionGroups: questionGroups.filter({
      surveys_form_id: formId,
    }),
  }
}
